import { ZfContainer, ZfInput, ZfLoadingSpinner, ZfStack, ZfTextButton } from '@zafire/react';
import AddPortfolioDialog from './AddPortfolioDialog';
import { useMemo, useState } from 'react';
import useGetFeatureFlags from './hooks/useGetFeatureFlags';
import { FeatureFlagName } from '../../services/portfolios/portfolioService';

//This page is included temporary for playwright test as component is not integrated yet
export const MockPage = () => {
  const [showDialog, setShowDialog] = useState(false);

  const [serviceAgreement, setServiceAgreement] = useState('');
  const [brUid, setBrUid] = useState('');
  const { data: featureFlag, isLoading: featureFlagLoading } = useGetFeatureFlags();

  const showPage = useMemo(() => {
    if (!featureFlagLoading) {
      return featureFlag?.find((item) => item.name === FeatureFlagName.PORTFOLIO_CREATE_API_ENABLED)?.enabled ?? false;
    }

    return false;
  }, [featureFlag, featureFlagLoading]);

  if (featureFlagLoading) {
    return <ZfLoadingSpinner size="extra-large" />;
  }

  if (!showPage) {
    return null;
  }

  return (
    <ZfContainer>
      <ZfStack spacing="medium" styles={{ paddingTop: '20px' }}>
        <ZfInput
          type="text"
          placeholder={'Service Agreement id for portfolio dialog'}
          onInputChange={(e) => setServiceAgreement(e.detail)}
          value={serviceAgreement}
        />
        <ZfInput
          type="text"
          placeholder={'BR uid for portfolio dialog'}
          onInputChange={(e) => setBrUid(e.detail)}
          value={brUid}
        />
        <ZfStack direction="row" spacing="small">
          <ZfTextButton onClick={() => setShowDialog(true)}>Test Dialog</ZfTextButton>
        </ZfStack>
        {showDialog && <AddPortfolioDialog brUid={brUid} serviceAgreementId={serviceAgreement} />}
      </ZfStack>
    </ZfContainer>
  );
};
